import { Route } from 'react-router-dom';
import BannerAdDesign from 'launch/routes/BannerAdDesign';
import BookCoverDesign from 'launch/routes/BookCoverDesign';
import GenericDesign from 'launch/routes/GenericDesign';
import LogoDesign from 'launch/routes/LogoDesign';
import ProductLabelDesign from 'launch/routes/ProductLabelDesign';
import ProductPackagingDesign from 'launch/routes/ProductPackagingDesign';
import BrandIdentityPack from 'launch/routes/BrandIdentityPack';
import LogoBrandGuide from 'launch/routes/LogoBrandGuide';
import LogoProductPackaging from 'launch/routes/LogoProductPackaging';
import FacebookCoverDesign from 'launch/routes/FacebookCoverDesign';
import React from 'react';
import withScrollToTop from 'common/components/withScrollToTop';

const categoryRouteMap = {
    '3d-design': GenericDesign,
    'banner-ad-design': BannerAdDesign,
    'book-cover-design': BookCoverDesign,
    'brand-identity-pack': BrandIdentityPack,
    'logo-brand-guide': LogoBrandGuide,
    'logo-product-packaging': LogoProductPackaging,
    'car-truck-van-wrap-design': GenericDesign,
    'card-invitation-design': GenericDesign,
    'character-mascot-design': GenericDesign,
    'cup-mug-design': GenericDesign,
    'icon-button-design': GenericDesign,
    illustrations: GenericDesign,
    'logo-business-card-design': LogoDesign,
    'logo-design': LogoDesign,
    'logo-website': LogoDesign,
    'magazine-cover-design': GenericDesign,
    'menu-design': GenericDesign,
    'merchandise-design': GenericDesign,
    'other-book-magazine-design': GenericDesign,
    'other-business-advertising': GenericDesign,
    'other-clothing-merchandise-design': GenericDesign,
    'other-design': GenericDesign,
    'other-packaging-label-design': GenericDesign,
    'other-website-app-design': GenericDesign,
    'postcard-flyer-design': GenericDesign,
    'poster-design': GenericDesign,
    'podcast-cover-design': GenericDesign,
    'album-cover-design': GenericDesign,
    'product-label-design': ProductLabelDesign,
    'product-packaging-design': ProductPackagingDesign,
    'signage-design': GenericDesign,
    'social-media-pack': LogoDesign,
    'sticker-design': GenericDesign,
    'tattoo-design': GenericDesign,
    'facebook-cover-design': FacebookCoverDesign,
};

const routes = Object.entries(categoryRouteMap).map(([category, component]) => {
    return (
        <Route
            key={category}
            path={`/launch/${category}/:draft_hash/visualbrief`}
            component={withScrollToTop(component)}
        />
    );
});

export default routes;
